window.addEventListener('load', function () {
    document.querySelectorAll('img.youtube-thumbnail').forEach(function (img) {
        if (img.naturalWidth < 121) {
            img.src = img.src.replace('maxresdefault', 'sddefault');

            img.addEventListener('load', function () {
                if (img.naturalWidth < 121) {
                    img.src = img.src.replace('sddefault', 'hqdefault');
                }
            });
        }
    });
});
